import React from 'react';

import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import Button from 'shared/button';
import Modal from 'components/modal';

type DialogProps = {
  buttonType?: string;
  children: React.ReactNode;
  className?: string;
  confirmLabel?: string;
  headerText?: string;
  icon?: FontAwesomeIconProps['icon'];
  iconClassName?: string;
  show: boolean;
  onConfirm: () => void;
  onHide: () => void;
};

export default function Dialog({
  className,
  buttonType,
  children,
  confirmLabel,
  headerText,
  icon,
  iconClassName,
  show,
  onConfirm,
  onHide,
  ...props
}: DialogProps) {
  let ConfirmButton;
  switch (buttonType) {
  case 'danger':
    ConfirmButton = Button.Danger;
    break;
  default:
    ConfirmButton = Button.Primary; 
  }

  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  return (
    <Modal
      {...props}
      className={className}
      show={show}
      onHide={onHide}
    >
      {headerText && <Modal.Header closeButton>{headerText}</Modal.Header>}
      <Modal.Body className="text-center py-5">
        {icon && <FontAwesomeIcon className={classNames('mb-4', iconClassName)} icon={icon} size="3x" />}
        {children}

        <div className="mt-4">
          <Button.Cancel className="me-2" onClick={onHide} />
          <ConfirmButton label={confirmLabel || 'Yes'} onClick={handleConfirm} />
        </div>
      </Modal.Body>
    </Modal>
  );
}
